import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { isIE } from '@jfs/utils'
import { isMobileWidth, isTabletWidth } from '../../util/util'

const styles = (viewPortWidth: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  return {
    topContainer: {
      bg: '#F6F7FA' as ColorOptions,
      overflow: 'scroll',
      h: 'calc(100vh - 72px)',
    } as BoxProps,
    boxOverview: {
      bg: '#F6F7FA' as ColorOptions,
      overflow: 'hidden',
      pt: 8,
    } as BoxProps,
    container: {
      ph: responsivePadding,
      align: 'center',
      justify: 'space-between',
      flexDirection: isMobile || isTab ? 'column' : 'row-reverse',
    } as BoxProps,
    imageContainer: {
      marginRight: isMobile || isTab ? 0 : 0,
      width: isMobile || isTab ? '90%' : '58%',
      overflow: 'visible',
      align: isMobile || isTab ? 'center' : undefined,
      height: isMobile ? 260 : 500,
      left: -responsivePadding / 2,
      top: 40,
    } as BoxProps,
    textContainer: {
      alignSelf: isMobile ? 'flex-start' : 'center',
      flex: isMobile || isTab || isIE() ? undefined : 1,
      align: isTab ? 'center' : undefined,
      width: isTab ? '70%' : undefined,
      maxWidth: isTab || isMobile ? undefined : '42%',
    } as BoxProps,
    rowContainer: {
      flexDirection: 'row',
      justify: isTab ? 'center' : 'undefined',
      align: 'center',
      marginLeft: -2,
    } as BoxProps,
    bgRadius: {
      height: '10vh',
      width: '100%',
      backgroundColor: 'WHITE',
      borderTopLeftRadius: isMobile || isTab ? 32 : 120,
      borderTopRightRadius: isMobile || isTab ? 32 : 120,
    } as BoxProps,
    bgRound: {
      height: '10vh',
      width: '100%',
      backgroundColor: '#F6F7FA' as ColorOptions,
    } as BoxProps,
  }
}

export { styles }
